import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	viewAllResults: {
		id: 'command-palette-quick-search.common.view-all-results',
		defaultMessage: 'View all results',
		description: 'Link to respective results page with search prefilled',
	},
});
